exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile-spinner-overlay__spinner-container__27NHn{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.mobile-spinner-overlay__spinner-container__27NHn .mobile-spinner-overlay__spinner__9D1NY{color:#555;color:-wix-colors-buttonsAndLinksColor}[data-layout=\"2\"] .mobile-spinner-overlay__spinner-container__27NHn .mobile-spinner-overlay__spinner__9D1NY{color:-wix-colors-mobileButtonsBackgroundColor}", ""]);

// exports
exports.locals = {
	"spinner-container": "mobile-spinner-overlay__spinner-container__27NHn",
	"spinnerContainer": "mobile-spinner-overlay__spinner-container__27NHn",
	"spinner": "mobile-spinner-overlay__spinner__9D1NY"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/mobile-spinner-overlay/mobile-spinner-overlay.styl
// module id = 1859
// module chunks = 1 2